<div class="w-full space-y-4 mt-6">
  <div class="block w-1/3 rounded-full shimmer-line shimmer-animate"></div>

  <div class="relative h-10 rounded-md shadow-sm shimmer-animate"></div>
</div>
